var map = {
  "./messages_id.json": [
    "42856",
    "9297"
  ],
  "./messages_th.json": [
    "63453",
    "2014"
  ],
  "./messages_uk.json": [
    "56621",
    "1102"
  ],
  "./messages_it.json": [
    "97016",
    "9937"
  ],
  "./messages_en.json": [
    "22126",
    "7267"
  ],
  "./messages_es.json": [
    "85157",
    "2918"
  ],
  "./messages_sv.json": [
    "23932",
    "6125"
  ],
  "./messages_tr.json": [
    "52363",
    "8808"
  ],
  "./messages_hi.json": [
    "91886",
    "8579"
  ],
  "./messages_ru.json": [
    "45416",
    "1089"
  ],
  "./messages_de.json": [
    "77398",
    "9099"
  ],
  "./messages_ko.json": [
    "383",
    "7620"
  ],
  "./messages_fr.json": [
    "39066",
    "2926"
  ],
  "./messages_fi.json": [
    "58936",
    "4465"
  ],
  "./messages_ja.json": [
    "75148",
    "4653"
  ],
  "./messages_cs.json": [
    "64851",
    "2672"
  ],
  "./messages_da.json": [
    "79610",
    "4119"
  ],
  "./messages_no.json": [
    "49694",
    "3587"
  ],
  "./messages_pt.json": [
    "55533",
    "1326"
  ],
  "./messages_vi.json": [
    "56648",
    "4321"
  ],
  "./messages_zh.json": [
    "91431",
    "5340"
  ],
  "./messages_nl.json": [
    "67135",
    "4916"
  ],
  "./messages_pl.json": [
    "85749",
    "1334"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 61408;
module.exports = __rspack_async_context;
